import React from 'react';
import PropTypes from 'prop-types';
import { ListItem as ListItemBase, Typography } from '@telus-uds/components-base';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ListItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    title,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(ListItemBase, {
    ref: ref,
    ...rest,
    children: [Boolean(title) && /*#__PURE__*/_jsx(Typography, {
      variant: {
        size: 'h4'
      },
      children: title
    }), children]
  });
});
ListItem.displayName = 'ListItem';
ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};
export default ListItem;